// export const parentAPI = "http://localhost/yfhbackend/";
export const parentAPI = "https://yfh.tenvicsports.com/backend/";
// export const parentAPI = "http://192.168.1.16/yfhbackend/";


// Login
export const Login = parentAPI + "Welcome/Login";

// Menu List
// export const MenuList = parentAPI + "ModuleController/MenuList";
export const MenuList = parentAPI + "account/menu-List";

// Feature Access List
export const FeatureAccessList = parentAPI + "ModuleController/ModuleFeatureAccessList";

// Institution List 
export const InstitutionList = parentAPI + "InstitutionController/InstitutionList";

// Nutritionist List 
export const NutritionistInstitutionList = parentAPI + "InstitutionController/GetNutritionistInstitutions";

// Psychotherapist List
export const PsychotherapistInstitutionList = parentAPI + "InstitutionController/GetPsychotherapistInstitutions";

// Students List
// export const StudentsList = parentAPI + "StudentsController/StudentsList";
export const StudentsList = parentAPI + "school/studentsList";

// Section List
// export const Section = parentAPI + "StudentsController/SectionsList";
export const Section = parentAPI + "school/sectionsList";

// Class List
// export const Class = parentAPI + "StudentsController/ClassesList";
export const Class = parentAPI + "school/classesList";

// Institution List
// export const InstDd = parentAPI + "SchedulesController/InstitutionByRole";
export const InstDd = parentAPI + "schedule/institutionByRole";


// Institution List
export const InstituteDd = parentAPI + "BatchesController/InstitutionByCoachId";

// Batch List
export const BatchList = parentAPI + "BatchesController/BatchList";

// Batch Student List
export const BatchStudentList = parentAPI + "BatchesController/BatchesStudentList";

// Program List 
export const ProgramList = parentAPI + "SportController/programNameList";

// Sport List
// export const SportList = parentAPI + "SportController/sportNameList";
export const SportList = parentAPI + "sports/sportList";

// Batch Details
export const BatchDetails = parentAPI + "BatchesController/BatchesID";

// Coach List
export const CoachList = parentAPI + "BatchesController/BatchesCoachList";

// Sport details Inst
export const SportDetailsInst = parentAPI + "BatchesController/detailsSportInst";

// Batches Student List 
export const BatchStudListMarked = parentAPI + "BatchesController/BatchesStudentListMarked";

// Archive Batch
export const ArchiveBatch = parentAPI + "BatchesController/ArchiveByBatchId";

// Create Batch
export const CreateBatch = parentAPI + "BatchesController/BatchesCreate";

// Duplicate Name
export const DuplicateName = parentAPI + "BatchesController/batchNamePresent";

// Schedule Type
export const ScheduleTypes = parentAPI + "SchedulesController/ScheduleTypes";

// List Batches
export const ListBatches = parentAPI + "SchedulesController/BatchByCoachId";

// List Schedules
export const listSchedules = parentAPI + "SchedulesController/ScheduledBatchList";

// Archive Schedule
export const archiveSchedule = parentAPI + "SchedulesController/ArchiveByScheduleId";

// Skill Set List 
export const ListSkillSet = parentAPI + "SchedulesController/SkillByCoachId";

// Create Schedule
export const CreateSchedule = parentAPI + "SchedulesController/ScheduleBatchCreate";

// Grade List
// export const GradeList = parentAPI + "AttendancesController/GradesList";
export const GradeList = parentAPI + "schedule/gradesList";

// Attendance Type List 
// export const AttendanceTypeList = parentAPI + "AttendancesController/AttendanceTypeList";
export const AttendanceTypeList = parentAPI + "schedule/attendanceList";

// Attendance List
// export const AttendanceList = parentAPI + "AttendancesController/AttendanceFullList";
export const AttendanceList = parentAPI + "school/attendanceFullList";

// Batch Attendance List
// export const BatchAttendanceList = parentAPI + "AttendancesController/StudentListByScheduleId";
export const BatchAttendanceList = parentAPI + "school/studentListByScheduleId";

// Batch List for attendance marking
// export const BatchByInstitution = parentAPI + "AttendancesController/BatchByInstitution";
export const BatchByInstitution = parentAPI + "school/batchByInstitution";

// Update Batch
export const updateBatchStudent = parentAPI + "BatchesController/StudentBatchesCreate";

// Schedule By Institution
// export const ScheduleByInstitution = parentAPI + "AttendancesController/ScheduleByInstitution";
export const ScheduleByInstitution = parentAPI + "schedule/scheduleByInstitution";

// Attendance Student List
// export const AttendanceStudentList = parentAPI + "AttendancesController/StudentList";
export const AttendanceStudentList = parentAPI + "school/studentList";

// Create New Attendance List 
export const CreateNewAttendanceList = parentAPI + "schedule/createNewAttendanceList";

// Sports List 
export const SportsList = parentAPI + "SportController/SportList";

// Programs List
// export const ProgramsList = parentAPI + "SportController/ProgramList";
export const ProgramsList = parentAPI + "sports/programList";

// Sport Skill List
export const SportSkillList = parentAPI + "SportController/sportSkillList";

// Inventory Institutions
export const InvenInstitutions = parentAPI + "InventoryController/InstitutionList";

// Goods List 
export const GoodsList = parentAPI + "InventoryController/GoodsList";

// Stock List
export const StockList = parentAPI + "InventoryController/StockList";

// Vendor List
export const VendorList = parentAPI + "InventoryController/VendorList";

// Product List 
export const ProductList = parentAPI + "InventoryController/ProductList";

// Category List
export const CategoryList = parentAPI + "InventoryController/CategoryList";

// Inventory Sport List
// export const InventorySportList = parentAPI + "InventoryController/SportsList";
export const InventorySportList = parentAPI + "inventory/sportsList";


// Create Category
export const CategoryCreate = parentAPI + "InventoryController/CategoryCreate";

// Update Category
export const UpdateCategory = parentAPI + "InventoryController/CategoryUpdate";

// Assessment Batch List
// export const AssessmentBatch = parentAPI + "AssessmentController/Programs";
export const AssessmentBatch = parentAPI + "school/programs";

// Assessment List 
// export const AssessmentList = parentAPI + "AssessmentController/AssessmentList";
export const AssessmentList = parentAPI + "AssessmentController/AssessmentList";

// Assessment Student List 
// export const AssessmentStudentList = parentAPI + "AssessmentController/StudentListByBatchId";
export const AssessmentStudentList = parentAPI + "schedule/studentListByBatchId";

// Assessment Chart List
// export const AssessmentChartList = parentAPI + "AssessmentController/AssessmentChartList";
export const AssessmentChartList = parentAPI + "schedule/assessmentChartList";

// Assessment Type List
// export const AssessmentTypeList = parentAPI + "AssessmentController/AssessmentTypeList";
export const AssessmentTypeList = parentAPI + "schedule/assessmentList";

// Assessment Date List 
// export const AssessmentDateList = parentAPI + "AssessmentController/AssessmentDates";
export const AssessmentDateList = parentAPI + "schedule/assessmentDates";

// Assessment Students
// export const AssessmentStudents = parentAPI + "AssessmentController/AssessmentStudents";
export const AssessmentStudents = parentAPI + "schedule/assessmentStudents";

// Assessment Students List
// export const AssesmentStudentsList = parentAPI + "AssessmentController/AssessmentStudentsList";
export const AssesmentStudentsList = parentAPI + "schedule/assessmentStudentsList";

// Create Assessment
// export const CreateAssessment = parentAPI + "AssessmentController/CreateNewAssessmentList";
export const CreateAssessment = parentAPI + "schedule/createNewAssessmentList";

// Institute Type List
// export const InstituteTypeList = parentAPI + "GeneralReportsController/instituteTypeList";
export const InstituteTypeList = parentAPI + "generalreports/instituteTypeList";

// Report Institution List 
// export const GetReportInstitutions = parentAPI + "GeneralReportsController/getInstitutions";
export const GetReportInstitutions = parentAPI + "generalreports/getInstitutions";

// Status Report 
export const GetStatusReport = parentAPI + "GeneralReportsController/displayStatusReport";

// institute Details
export const GetInstituteDetails = parentAPI + "GeneralReportsController/displayDetailsInst";

// general institute list
export const GeneralInstituteList = parentAPI + "GeneralReportsController/GeneralInstitutionList";

// get class list
export const GetClass = parentAPI + "GeneralReportsController/GetClass";

// get section list 
export const GetSection = parentAPI + "GeneralReportsController/getSectionByClass";

// get student report
export const GetStudentReport = parentAPI + "GeneralReportsController/StudentDetails";

// coach list
// export const GetCoachList = parentAPI + "GeneralReportsController/getcoach";
export const GetCoachList = parentAPI + "generalreports/getCoach";

// report batch list
export const GetRprtBatchList = parentAPI + "GeneralReportsController/getBatch";

// attendance report 
export const GetAttendanceReport = parentAPI + "GeneralReportsController/getAttendanceReport";

// report attendance details
export const GetReportAttendanceDetails = parentAPI + "GeneralReportsController/ReportAttendance";

// attendance report export
export const AttendanceReportExport = parentAPI + "GeneralReportsController/attendancereportExport";

// assessment batch list
export const GetBatchAssessment = parentAPI + "GeneralReportsController/getBatchAssessment";

// assessment list
export const GetAssessment = parentAPI + "GeneralReportsController/getAssessment";

// assessment report
export const GetAssessmentReport = parentAPI + "GeneralReportsController/getAssessmentReport";

// view assessment report 
export const ReportAssessmentData = parentAPI + "GeneralReportsController/ReportAssessmentData";

// assessment report export
export const AssessmentReportExport = parentAPI + "GeneralReportsController/getAssessmentReportExport";

// sports type list
export const SportsTypeList = parentAPI + "GeneralReportsController/sportrsTypeList";

// institution sports data
export const GetInstitutionSportsData = parentAPI + "GeneralReportsController/getInstitutionSportsData";

// institution sports data export
export const SportsNameExportToExcel = parentAPI + "GeneralReportsController/sportsNameExportToExcel";

// video name by sport
export const VideoNameBySport = parentAPI + "TutorialController/videoNameById";

// document list
export const DocumentList = parentAPI + "TutorialController/documentList";

// reference sport list
export const ReferenceSport = parentAPI + "SportController/ReferenceSport";

// reference link
export const ReferenceLink = parentAPI + "TutorialController/ReferenceLink";

// admin schedule list
export const adminScheduleList = parentAPI + "scheduleAttendanceController/scheduleList";

// admin schedule details
export const adminScheduleDetails = parentAPI + "scheduleAttendanceController/GetSchedule";

// admin schedule update
export const adminScheduleUpdate = parentAPI + "scheduleAttendanceController/scheduleUpdate";

// admin attendance list
export const adminAttendanceList = parentAPI + "scheduleAttendanceController/attendanceList";

// admin attendance details
export const adminAttendanceDetails = parentAPI + "scheduleAttendanceController/GetAttendanceData";

// admin attendance update
export const adminAttendanceUpdate = parentAPI + "scheduleAttendanceController/attendanceUpdate";

// admin grade list
export const adminGradeList = parentAPI + "scheduleAttendanceController/gradeList";

// admin grade details
export const adminGradeUpdateDetails = parentAPI + "scheduleAttendanceController/gradeUpdateData";

// admin grade update
export const adminGradeUpdate = parentAPI + "scheduleAttendanceController/gradeUpdate";

// admin assessment list
export const adminAssessmentList = parentAPI + "scheduleAttendanceController/assessmentList";

// admin assessment details
export const adminAssessmentData = parentAPI + "scheduleAttendanceController/GetAssessmentData";

// admin assessment update
export const adminAssessmentUpdate = parentAPI + "scheduleAttendanceController/assessmentUpdate";

// admin cc skill list
export const adminCcSkillsList = parentAPI + "scheduleAttendanceController/ccSkillList";

// admin cc skill details
export const adminCcSkillsData = parentAPI + "scheduleAttendanceController/ccskillUpdateData";

// admin cc skill update
export const adminCcSkillsUpdate = parentAPI + "scheduleAttendanceController/ccskillUpdate";

// admin ops manager list
export const adminOpsMgrLst = parentAPI + "InstitutionController/InstitutionManagerList";

// admin sport coach list 
export const adminSportCoachList = parentAPI + "InstitutionController/SportCoachList";

// admin group list
export const adminGroupList = parentAPI + "InstitutionController/InstitutionGroupList";

// admin type list
export const adminTypeList = parentAPI + "InstitutionController/InstitutionTypeList";

// support case list
export const supportCaseList = parentAPI + "SupportController/SupportCaseList";

// goods sports list
export const goodsSportsById = parentAPI + "InventoryController/SportById";

// coaches by sports id
export const coachesBySportId = parentAPI + "InventoryController/CoachById";

// products by sports id
export const productsBySportsId = parentAPI + "InventoryController/ProductBySport";

// save issue goods
export const saveIssueGoods = parentAPI + "InventoryController/IssueGoods";

// return Goods
export const returnGoods = parentAPI + "InventoryController/ReturnGoods";

// get nutritionist list
export const getNutritionistList = parentAPI + "InstitutionController/GetInstitutionNutritionistList";

// all batch list
export const getAllBatches = parentAPI + "BatchesController/ExceptallBatchList";

// swap batches sport list
export const getSBSportList = parentAPI + "BatchesController/SportDisplay";

// swap batches all batch list
export const getSBBatchList = parentAPI + "BatchesController/allBatchList";

// swap batches students list
export const getSBStudentList = parentAPI + "BatchesController/detailsOfStudent";

// swap batch
export const swapFullBatch = parentAPI + "BatchesController/swapBatchesCreate";

// ins count
export const instStudCounts = parentAPI + "AnalyticsController/GetInstitutionStudentCount";

// ins count by sport
export const instStudCountSprt = parentAPI + "AnalyticsController/GetInstitutionStudentCountBySport";

// ins count by year
export const instCountByYear = parentAPI + "AnalyticsController/GetInstitutionByYear";

// ins count by month
export const insCountByMonth = parentAPI + "AnalyticsController/GetSessionByMonth";

// create institute
export const createInstitute = parentAPI + "InstitutionController/InstitutionCreate";

// update institute
export const updateInstitute = parentAPI + "InstitutionController/InstitutionUpdate";

// unassigned manager for institutes (Inst List)
export const AsignOpsInstList = parentAPI + "InstitutionController/ManagersInstitutionList";

// Ops mgr list for assigning ops mgr for institutes
export const MgrList = parentAPI + "InstitutionController/ManagerList";

// Add Ops Manager for institute
export const SaveInstituteOpsManager = parentAPI + "InstitutionController/AddManager";

// Update Ops Manager for institute
export const UpdateInstituteOpsManager = parentAPI + "InstitutionController/UpdateManager";

// Coach List for sport id
export const AssignCoachList = parentAPI + "Welcome/CoachList";

// check sport coach exist
export const CheckSportCoach = parentAPI + "InstitutionController/GetCheckCoachSportExists";

// save sport coach
export const AddSportCoach = parentAPI + "InstitutionController/AddSportCoach";

// get physioTherapist list
export const GetPsychotherapistList = parentAPI + "InstitutionController/GetInstitutionPhysiotherapistList";

// get therapist list
export const GetTherapist = parentAPI + "InstitutionController/InstitutionPhysiotherapist";

// update group
export const UpdateGroup = parentAPI + "InstitutionController/InstitutionGroupUpdate";

// add group
export const AddGroup = parentAPI + "InstitutionController/InstitutionGroupCreate";

// add type
export const AddType = parentAPI + "InstitutionController/InstitutionTypeCreate";

// update type
export const UpdateType = parentAPI + "InstitutionController/InstitutionTypeUpdate";

// batch student list
export const BatchStudents = parentAPI + "BatchesController/BatchStudent";

// check sport name exists
export const CheckSportName = parentAPI + "SportController/sportNamePresent";

// createSport
export const CreateSport = parentAPI + "SportController/SportCreate";

// update sport
export const UpdateSport = parentAPI + "SportController/SportUpdate";

// create program
export const CreateProgram = parentAPI + "SportController/ProgramCreate";

// update program
export const UpdateProgram = parentAPI + "SportController/ProgramUpdate";

// edit skill details
export const GetSkillDetails = parentAPI + "SportController/SkillList";

// save student
export const SaveStudent = parentAPI + "school/studentCreate";

// update Student
export const UpdateStudent = parentAPI + "school/studentUpdate";

// get bmi batches
export const GetBMIBatches = parentAPI + "generalreports/getBatchNameBMI";

// get bmi report
export const GetBMIReport = parentAPI + "generalreports/getBmiReport";

// bmi report export
export const ExportBMIReport = parentAPI + "generalreports/getBmiReportExport";

// all coach performance report
export const AllCoachPerformance = parentAPI + "generalreports/getCoachPerformanceReports";
// export const AllCoachPerformance = parentAPI + "GeneralReportsController/getCoachPerformanceReports";

// coach performance export
// export const ExportCoachPerformanceReport = parentAPI + "GeneralReportsController/coachPerformanceExport";
export const ExportCoachPerformanceReport = parentAPI + "generalreports/coachPerformanceExport";

// coach attendance report count
// export const CoachAttendanceReportCount = parentAPI + "GeneralReportsController/CoachAttendanceReportCount";
export const CoachAttendanceReportCount = parentAPI + "generalreports/coachAttendanceReportCount";

// coach attendance report
// export const CoachReportAttendance = parentAPI + "GeneralReportsController/CoachAttendanceReport";
export const CoachReportAttendance = parentAPI + "generalreports/coachAttendanceReport";

// coach attendance report export
// export const CoachAttendanceReportExport = parentAPI + "GeneralReportsController/ExportCoachAttendanceReport";
export const CoachAttendanceReportExport = parentAPI + "generalreports/exportCoachAttendanceReport";

// get data
export const GetData = parentAPI + "generalreports/getData";

// get all user data
export const GetAllUserData = parentAPI + "generalreports/getAllUserData";

// role user details
export const GetRoleUserDetails = parentAPI + "generalreports/roleUserDetails";

// export internal user details
export const ExportInternalUsersReport = parentAPI + "generalreports/exportgetdetailsUserDetail";

// user list
export const UserList = parentAPI + "account/userList";

// user details
export const UserDetails = parentAPI + "account/userDetails";

// billing type
export const BillingTypeList = parentAPI + "billing/billingTypeList";

// module list
export const ModuleList = parentAPI + "account/module-list";

// roles list
export const RolesList = parentAPI + "account/roleList";

// manager list
export const ManagerList = parentAPI + "account/managerLists";

// save user
export const SaveNewUser = parentAPI + "account/registerUser";

// update user
export const UpdateUser = parentAPI + "account/updateUser";

// section by class Id
export const SectionsByClassId = parentAPI+"school/sectionByClassId";

// slab list
export const SlabList = parentAPI + "school/slabsList";

// create Section 
export const SectionCreate = parentAPI + "school/sectionCreate";

// update section
export const SectionUpdate = parentAPI + "school/sectionUpdate";

// archieve section
export const ArchieveSection = parentAPI + "school/archiveSectionById";

// create Class 
export const ClassCreate = parentAPI + "school/classCreate";

// update Class
export const ClassUpdate = parentAPI + "school/classUpdate";

// archieve Class
export const ArchieveClass = parentAPI + "school/archiveClassById";

// get Profile details
export const ProfileDetails = parentAPI + "account/getUserProfile";

// change password
export const ChangePassword = parentAPI + "account/changePassword";

// Assessment Chart List Edit
export const AssessmentEditChartList = parentAPI + "schedule/assessmentChartEditList";

// Create Assessment
export const UpdateAssessment = parentAPI + "schedule/modifyAssessmentList";